export default "__VITE_ASSET__B763PvKG__"